import { useNavigate } from 'react-router-dom';
import { PageContainer } from "../../../../Common/Components/BaseComponents/PageContainer";

const PricingHomePage = () => {
    const navigate = useNavigate();

    return (
        <PageContainer title="ניהול תמחור">
            <div className="max-w-xl mx-auto p-8 bg-white rounded shadow">

                {/* מקטע הכפתורים - עמודה עם ריווח בין הכפתורים */ }
                <div className="flex flex-col gap-6">
                    {/* כפתור לתמחור סביבת עבודה */ }
                    <button
                        className="bg-blue-600 hover:bg-blue-700 text-white py-4 rounded text-lg font-semibold shadow"
                        onClick={ () => navigate('/billing/pricing/workspace') } // ניווט לנתיב תמחור סביבת עבודה
                    >
                        תמחור סביבת עבודה
                    </button>

                    {/* כפתור לתמחור חדרי ישיבות */ }
                    <button
                        className="bg-blue-600 hover:bg-blue-700 text-white py-4 rounded text-lg font-semibold shadow"
                        onClick={ () => navigate('/billing/pricing/meeting-room') } // ניווט לנתיב תמחור חדרי ישיבות
                    >
                        תמחור חדרי ישיבות
                    </button>

                    {/* כפתור לתמחור לאונג' */ }
                    <button
                        className="bg-blue-600 hover:bg-blue-700 text-white py-4 rounded text-lg font-semibold shadow"
                        onClick={ () => navigate('/billing/pricing/lounge') } // ניווט לנתיב תמחור לאונג'
                    >
                        תמחור לאונג'
                    </button>
                </div>
            </div>
        </PageContainer>
    );
};

export default PricingHomePage;
